<!-- eslint-disable @angular-eslint/template/prefer-control-flow -->
<!-- TODO whitespace is added before each text after migrating to control flow
Migrate to control flow when github issues are fixed:
https://github.com/prettier/prettier/issues/16577 & 
https://github.com/angular/angular/issues/56323 &
https://github.com/angular/angular/issues/54077 
-->
<div *ngIf="addressType === 'generic'" data-testid="shop-address" class="shop-address paragraph-small">
    <p class="paragraph-small"> {{ shop.streetAddress1 }}, </p>
    <ng-container *ngIf="shop.streetAddress2">{{ shop.streetAddress2 }},</ng-container>
    <ng-container *ngIf="shop.streetAddress3">&nbsp;{{ shop.streetAddress3 }},</ng-container>
    <p class="paragraph-small"> {{ shop.postalCode }} {{ shop.city }}, {{ shop.country }} </p>
</div>
<div *ngIf="addressType === 'us'" data-testid="shop-address" class="shop-address paragraph-small">
    {{ shop.streetAddress1 }},
    <ng-container *ngIf="shop.streetAddress2">{{ shop.streetAddress2 }},</ng-container>
    <ng-container *ngIf="shop.streetAddress3">&nbsp;{{ shop.streetAddress3 }},</ng-container>
    <p class="paragraph-small">
        {{ shop.city }},
        <ng-container *ngIf="shop.area">{{ shop.area }} </ng-container>
        <ng-container *ngIf="shop.postalCode">{{ shop.postalCode }}</ng-container>
        <ng-container *ngIf="shop.area || shop.postalCode">,</ng-container>

        {{ shop.country }}
    </p>
</div>
<div *ngIf="addressType === 'jp'" data-testid="shop-address" class="shop-address paragraph-small">
    <p class="paragraph-small"> {{ shop.postalCode }} {{ shop.country }} {{ shop.city }} {{ shop.streetAddress1 }} </p>
    <ng-container *ngIf="shop.streetAddress2">{{ shop.streetAddress2 }}</ng-container>
    <ng-container *ngIf="shop.streetAddress3">&nbsp;{{ shop.streetAddress3 }}</ng-container>
</div>
<div *ngIf="addressType === 'my_sg'" data-testid="shop-address" class="shop-address paragraph-small">
    <p class="paragraph-small"> {{ shop.streetAddress1 }}, </p>
    <ng-container *ngIf="shop.streetAddress2">{{ shop.streetAddress2 }},</ng-container>
    <ng-container *ngIf="shop.streetAddress3">&nbsp;{{ shop.streetAddress3 }},</ng-container>
    <p class="paragraph-small">
        <ng-container *ngIf="shop.city">&nbsp;{{ shop.city }}, </ng-container>
        <ng-container *ngIf="shop.postalCode">{{ shop.postalCode }}, </ng-container>
        <!-- Following ng-container is NOT useless: it prevents double space before text -->
        <ng-container>{{ shop.country }}</ng-container>
    </p>
</div>
<div *ngIf="addressType === 'mx'" data-testid="shop-address" class="shop-address paragraph-small">
    <p class="paragraph-small">{{ shop.streetAddress1 }}&nbsp;</p>
    <p class="paragraph-small">
        <ng-container *ngIf="shop.streetAddress2">{{ shop.streetAddress2 }}, </ng-container>
        <ng-container *ngIf="shop.streetNumber">{{ shop.streetNumber }}, </ng-container>
        <ng-container *ngIf="shop.additionalNumber">{{ shop.additionalNumber }}&nbsp;</ng-container>
    </p>
    <p class="paragraph-small">
        <ng-container *ngIf="shop.neighborhood">{{ shop.neighborhood }}, </ng-container>
        <ng-container *ngIf="shop.district">{{ shop.district }}&nbsp;</ng-container>
    </p>
    <p class="paragraph-small">
        <ng-container *ngIf="shop.postalCode">{{ shop.postalCode }}, </ng-container>
        <ng-container *ngIf="shop.city">{{ shop.city }}&nbsp;</ng-container>
    </p>
    <ng-container *ngIf="shop.country">{{ shop.country }}</ng-container>
</div>
